exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{font-size:16px}@media (min-width:576px){html{font-size:24px}}#app{font-family:Frutiger\\ 57Cn,Avenir,Helvetica,Arial,sans-serif;font-weight:400;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50}#content{padding:3rem 0 3.4rem;background:#f26722;color:#fff}h1,h2,h3,h4,h5{font-family:SC Gum Kids;font-weight:400;font-style:normal}#content h2{margin-bottom:.4em;font-size:2.2rem;line-height:1.2em;text-transform:uppercase;color:#f6fcae}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49c67250","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 35
// module chunks = 0